function Guinea({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_1314)">
  <path d="M21.5654 0.99525C19.832 0.352062 17.9572 0 16 0C14.0429 0 12.1682 0.352063 10.4349 0.995125L9.73926 16L10.4349 31.0049C12.1682 31.648 14.0429 32 16 32C17.9573 32 19.832 31.648 21.5654 31.0047L22.261 16L21.5654 0.99525Z" fill="#FFDA44"/>
  <path d="M0 16C0 22.8794 4.342 28.7441 10.4348 31.0047V0.995117C4.342 3.25587 0 9.12049 0 16Z" fill="#D80027"/>
  <path d="M32 16C32 9.12049 27.658 3.25587 21.5652 0.995117V31.0048C27.658 28.7441 32 22.8794 32 16Z" fill="#6DA544"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default Guinea;
